<template>
  <article class="gs-product-list-card">
    <button
      type="button"
      class="gs-product-list-card__media"
      :aria-label="`Edit ${product.name}`"
      @click="sendToEditProduct"
    >
      <img
        v-if="productImage"
        class="gs-product-list-card__image"
        :src="productImage"
        :alt="product.name"
      />
      <gifts-icon v-else class="gs-product-list-card__placeholder" />
    </button>
    <div class="gs-product-list-card__content">
      <div class="gs-product-list-card__main">
        <div class="gs-product-list-card__title-row">
          <h3>
            {{ product.name }}
            <span v-if="product.is_test_mode_enabled">(Test Mode)</span>
          </h3>
          <span class="gs-product-list-card__badge">{{ productTypeName }}</span>
        </div>
        <p class="gs-product-list-card__meta">
          <span>{{ $t('frontend_internal_name') }}: {{ product.internal_name ? product.internal_name : 'N/A' }}</span>
        </p>
        <p class="gs-product-list-card__description">{{ product.description || 'No description added.' }}</p>
      </div>
      <div class="gs-product-list-card__actions">
        <div class="gs-product-list-card__icons">
          <button
            v-for="option in menuItemsIcons"
            :key="option.text"
            type="button"
            class="gs-product-list-card__icon-button"
            :aria-label="option.text"
            :title="option.text"
            @click="option.callback()"
            v-tooltip="option.text"
          >
            <component :is="option.icon" />
          </button>
        </div>
        <drop-menu :menu-items="menuItems" small></drop-menu>
      </div>
    </div>
  </article>
</template>

<script>
import ChartBarIcon from '@/assets/images/icons/ChartBarIcon.svg';
import PencilIcon from '@/assets/images/icons/PencilIcon.svg';
import ShoppingCartIcon from '@/assets/images/icons/ShoppingCartIcon.svg';
import CloneIcon from '@/assets/images/icons/CloneIcon.svg';
import MegaphoneIcon from '@/assets/images/icons/MegaphoneIcon.svg';
import GiftsIcon from '@/assets/images/icons/GiftsIcon.svg';

export default {
  name: 'ProductListAsset',
  components: {
    GiftsIcon,
  },
  props: {
    product: {},
    productType: {},
    funnel: {},
    admin: {
      default: false,
    },
  },
  computed: {
    productTypeName() {
      let productTypeName = '';

      if (this.productType != 'atc_order_bumps') {
        if (this.product.type == 1) productTypeName = this.$t('frontend_groovesell_tag_frontend');
        if (this.product.type == 2) productTypeName = this.$t('frontend_product_index_tab_upsell_downsell');
        if (this.product.type == 3) productTypeName = this.$t('frontend_product_step1_order_bump');
      } else {
        productTypeName = this.$t('upsell_add_to_cart_order_bumps');
      }

      return productTypeName;
    },
    productImage() {
      let productImage = false;

      if (
        this.product.checkout_page_options &&
        this.product.checkout_page_options != null &&
        this.product.checkout_page_options.product_image &&
        this.product.checkout_page_options.product_image != ''
      )
        productImage = this.product.checkout_page_options.product_image;

      return productImage;
    },
    isProductComplete() {
      let productComplete = true;
      if (this.product.is_wizard_complete && this.product.is_complete) {
        productComplete = false;
      }
      return productComplete;
    },
    menuItemsIcons() {
      const menuItemsIcons = [];
      menuItemsIcons.push({
        icon: PencilIcon,
        text: this.$t('frontend_product_edit'),
        callback: () =>
          this.$emit('onProductEdit', this.product.id, this.isProductComplete),
      });
      if (this.productType != 'atc_order_bumps') {
        menuItemsIcons.push({
          icon: ShoppingCartIcon,
          text: this.$t('forntend_checkout_links'),
          callback: () => this.$emit('onProductCheckOutLinks', this.product.id),
        });
      }
      if (this.admin && this.productType != 'atc_order_bumps') {
        menuItemsIcons.push({
          icon: ChartBarIcon,
          text: this.$t('frontend_groovesell_menu_items_projections'),
          callback: () => this.$emit('onProductProjection', this.product.id),
        });
      }
      if (this.productType != 'atc_order_bumps') {
        menuItemsIcons.push({
          icon: CloneIcon,
          text: this.$t('frontend_product_clone'),
          callback: () => this.$emit('onProductClone', this.product.id),
        });
      }
      menuItemsIcons.push({
        icon: MegaphoneIcon,
        text: this.$t('frontend_funnels_affiliate_signup_promo_tools'),
        callback: () => this.$emit('onManagePromotools', this.funnel.id),
      });
      return menuItemsIcons;
    },
    menuItems() {
      const menuItems = [];
      if (this.productType != 'atc_order_bumps') {
        if (!this.product.is_test_mode_enabled) {
          menuItems.push({
            text: this.$t('frontend_groovesell_menu_items_enable_test_mode'),
            callback: () =>
              this.$emit('onProductEnableTestMode', this.product.id, 1),
          });
        } else {
          menuItems.push({
            text: this.$t('frontend_groovesell_menu_items_disable_test_mode'),
            callback: () =>
              this.$emit('onProductEnableTestMode', this.product.id, 0),
          });
        }
      }
      if (this.productType != 'atc_order_bumps') {
        menuItems.push({
          text: this.$t('frontend_groovesell_menu_items_tracking_links'),
          callback: () => this.$emit('onProductTracking', this.product.id),
        });
      }
      if (this.product.is_main != true) {
        menuItems.push({
          text: this.$t('frontend_groovesell_menu_items_delete_product'),
          callback: () => this.$emit('onProductDelete', this.product.id),
        });
      }
      if (
        this.productType == 'all' &&
        !this.product.hasOwnProperty('is_main')
      ) {
        const Trackingindex = menuItems.findIndex(
          (x) => x.text == this.$t('frontend_groovesell_menu_items_tracking_links')
        );
        menuItems.splice(Trackingindex, 1);
        const checkOutLinkindex = menuItems.findIndex(
          (x) => x.text == this.$t('forntend_checkout_links')
        );
        menuItems.splice(checkOutLinkindex, 1);
        const cloneindex = menuItems.findIndex(
          (x) => x.text == this.$t('frontend_product_clone')
        );
        menuItems.splice(cloneindex, 1);
      }

      return menuItems;
    },
  },
  methods: {
    backgroundImageUrl(url) {
      if (url) {
        return `url("${url}")`;
      }

      return '';
    },
    sendToEditProduct() {
      this.$emit('onProductEdit', this.product.id, this.isProductComplete);
    },
  },
};
</script>

<style lang="scss">
.gs-product-list-card {
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  margin: 10px 0;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e4e8f1;
  border-radius: 8px;
  box-shadow: 0 14px 32px rgba(31, 37, 72, .06);
}

.gs-product-list-card__media {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 126px;
  padding: 18px;
  color: #ff5b7f;
  background: #fbfcff;
  border: 0;
  border-right: 1px solid #edf0f6;
  cursor: pointer;
}

.gs-product-list-card__image,
.gs-product-list-card__placeholder {
  width: 100%;
  height: 88px;
  object-fit: contain;
}

.gs-product-list-card__placeholder {
  fill: currentColor;
}

.gs-product-list-card__content {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  padding: 18px 20px;
}

.gs-product-list-card__main {
  min-width: 0;
}

.gs-product-list-card__title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.gs-product-list-card__title-row h3 {
  margin: 0;
  color: #171b3f;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.28 !important;
}

.gs-product-list-card__badge {
  flex-shrink: 0;
  padding: 5px 8px;
  color: #ff5b7f;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
  background: #fff5f7;
  border-radius: 6px;
}

.gs-product-list-card__meta {
  margin: 0 0 8px;
  color: #7c849c;
  font-size: 12px;
}

.gs-product-list-card__description {
  max-width: 760px;
  margin: 0;
  color: #4f5875;
  font-size: 14px;
  line-height: 1.55;
}

.gs-product-list-card__actions,
.gs-product-list-card__icons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.gs-product-list-card__actions {
  flex-shrink: 0;
}

.gs-product-list-card__icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: #5f6884;
  background: #f7f8fc;
  border: 1px solid #e4e8f1;
  border-radius: 6px;
}

.gs-product-list-card__icon-button:hover {
  color: #ff5b7f;
  background: #fff5f7;
  border-color: #ffc4d1;
}

.gs-product-list-card__media:focus-visible,
.gs-product-list-card__icon-button:focus-visible {
  outline: 3px solid rgba(255, 91, 127, .3);
  outline-offset: -3px;
}

.gs-product-list-card__icon-button svg {
  width: 18px;
  height: 18px;
  fill: currentColor;
}

@media (max-width: 800px) {
  .gs-product-list-card {
    grid-template-columns: 1fr;
  }

  .gs-product-list-card__media {
    border-right: 0;
    border-bottom: 1px solid #edf0f6;
  }

  .gs-product-list-card__content {
    flex-direction: column;
  }
}
</style>
